import type { AudioPlayerCardImage } from "../../types/audio-player-card";

import Image from "next/image";
import { cn } from "../../utils/classnames";

type AudioPlayerCardCoverArtProps = {
  className?: string;
  coverArt: AudioPlayerCardImage;
};

function AudioPlayerCardCoverArt({
  className,
  coverArt,
}: AudioPlayerCardCoverArtProps) {
  return (
    <div
      className={cn(
        "relative aspect-square w-[134px] shrink-0 overflow-hidden rounded-2xl lg:w-[190px]",
        className,
      )}
    >
      <Image
        alt={coverArt.alt}
        className="object-cover"
        fill
        sizes="(min-width: 1024px) 190px, 134px"
        src={coverArt.src}
      />
    </div>
  );
}

export { AudioPlayerCardCoverArt };
